<template>
  <div
    id="molecule-container"
    style="background-color: #b3e5fc; width: 500px; height: 500px; position: relative; overflow: hidden;"
  >
    <!-- Imagen SVG central desde assets -->
    <img
      :src="require('@/assets/ralph.svg')"
      alt="Central SVG"
      class="floating-image"
      style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10; width: 400px; height: 400px;"
    />

    <!-- Contenedor de moléculas -->
    <svg
      id="svg-animation"
      xmlns="http://www.w3.org/2000/svg"
      style="width: 100%; height: 100%; position: absolute; top: 0; left: 0;"
    >
      <defs>
        <g id="molecule">
          <circle cx="-6" cy="0" r="5" fill="white" />
          <circle cx="6" cy="0" r="5" fill="white" />
          <line x1="-6" y1="0" x2="6" y2="0" stroke="white" stroke-width="2" />
        </g>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moleculeCount: 10, // Número de moléculas
      molecules: [], // Array para rastrear moléculas y su movimiento
    };
  },
  mounted() {
    this.createMolecules();
    this.startAnimation();
  },
  methods: {
    createMolecules() {
      const container = document.getElementById("svg-animation");

      for (let i = 0; i < this.moleculeCount; i++) {
        const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
        use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#molecule");

        const x = Math.random() * 500;
        const y = Math.random() * 500;
        use.setAttribute("x", x);
        use.setAttribute("y", y);

        container.appendChild(use);

        this.molecules.push({
          element: use,
          x,
          y,
          dx: Math.random() * 2 - 1,
          dy: Math.random() * 2 - 1,
          angle: 0,
          rotationSpeed: Math.random() * 2 + 1,
        });
      }
    },
    startAnimation() {
      const container = document.getElementById("molecule-container");
      const containerWidth = container.offsetWidth;
      const containerHeight = container.offsetHeight;

      const animate = () => {
        this.molecules.forEach((molecule) => {
          molecule.x += molecule.dx;
          molecule.y += molecule.dy;

          if (molecule.x <= 0 || molecule.x >= containerWidth) molecule.dx *= -1;
          if (molecule.y <= 0 || molecule.y >= containerHeight) molecule.dy *= -1;

          molecule.angle += molecule.rotationSpeed;
          if (molecule.angle >= 360) molecule.angle -= 360;

          molecule.element.setAttribute("x", molecule.x);
          molecule.element.setAttribute("y", molecule.y);
          molecule.element.setAttribute(
            "transform",
            `rotate(${molecule.angle} ${molecule.x + 6} ${molecule.y})`
          );
        });

        requestAnimationFrame(animate);
      };

      animate();
    },
  },
};
</script>

<style scoped>
/* Animación flotante para la imagen central */
@keyframes float {
  0% {
    transform: translate(-50%, -50%) translateY(0);
  }
  50% {
    transform: translate(-50%, -50%) translateY(-10px);
  }
  100% {
    transform: translate(-50%, -50%) translateY(0);
  }
}

.floating-image {
  animation: float 4s ease-in-out infinite;
}
</style>
